// extracted by mini-css-extract-plugin
export default {"image":"PieceOriginalImage_image__97P8S"};